import { OptJobType } from 'api/optJobs/optJobs.api'
import { useMemo } from 'react'

export type OverrideAliasInput = {
  regularOptJobType: Extract<OptJobType, 'regular' | 'regular_wip'>
  comparePlansFeatureFlag: boolean
  previousRegularOptJobTime: string | ISODateTime
  datasetStartTime: ISODateTime
  datasetEndTime: ISODateTime
  productionPlanStartTime: ISODateTime
  measEndTime: ISODateTime
}

export function useOverrides({
  regularOptJobType,
  comparePlansFeatureFlag,
  previousRegularOptJobTime,
  datasetStartTime,
  datasetEndTime,
  productionPlanStartTime,
  measEndTime,
}: OverrideAliasInput) {
  const baseAlias = useMemo(
    () => ({
      previous_regular_opt_job_time: previousRegularOptJobTime,
    }),
    [previousRegularOptJobTime]
  )

  return useMemo(() => {
    const optJobTypeAliases: Record<string, string> =
      regularOptJobType === 'regular_wip'
        ? {
            optjob_type: 'regular_wip',
            opt_job_type_id: '$regular_wip',
            plan_optjob_type: 'regular_wip',
            plan_opt_job_type_id: '$regular_wip',
          }
        : {}

    if (!comparePlansFeatureFlag) {
      return { overrideAlias: { ...optJobTypeAliases, ...baseAlias } }
    }

    return {
      overrideAlias: {
        ...optJobTypeAliases,
        ...baseAlias,
        start_time: datasetStartTime,
        end_time: datasetEndTime,
        offset_start_time: 0,
        offset_end_time: 0,
        plan_start_time: productionPlanStartTime,
        plan_end_time: datasetEndTime,
        meas_start_time: datasetStartTime,
        meas_end_time: measEndTime,
        plan_offset_end_time: 0,
        meas_offset_start_time: 0,
      },
    }
  }, [
    baseAlias,
    comparePlansFeatureFlag,
    datasetStartTime,
    datasetEndTime,
    productionPlanStartTime,
    measEndTime,
    regularOptJobType,
  ])
}
